import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class OlderThan18ValidationRule extends ValidationRule {
  constructor(key: string) {
    if (!key) {
      key = ValidationTypes.olderThan18;
    }

    super(key);
  }

  isValid(value: Date): boolean {
    if (value == null) {
      return true;
    }

    value = new Date(value);
    const today18YearsAgo = new Date();
    today18YearsAgo.setFullYear(today18YearsAgo.getFullYear() - 18);
    return value <= today18YearsAgo;
  }
}
